import { useAuth } from "./wp.auth.service";

export const hasRole = (role, user) => {
	if (!user) {
		user = useAuth()?.user; /* eslint-disable-line no-param-reassign */
	}

	if (!user || !user.roles) {
		return false;
	}

	return user.roles.indexOf(role) !== -1; /* eslint-disable-line no-magic-numbers */
};
